import { useState, useEffect } from 'react';
import Notification from './interfaces/Notification';
import { getNotification, getImsClose } from './Notification.service';
import GridComponent from '../../component/grid/GridComponent.component';
import AddIcon from '@material-ui/icons/Add';
import AssignmentIcon from '@material-ui/icons/Assignment';
import ButtonBack from '../../component/buttton/ButtonBack.component';
import ButtonLink from '../../component/buttton/ButtonLink.component';
import Card from './components/Card.component';
import { AxiosResponse } from 'axios';
import { useSnackbar } from '../../context/Snackbar';
import { NotificationInterface } from './interfaces/NotificationComponent';

export default function NotificationComponent({ close }: NotificationInterface) {

    const { setSnackbar } = useSnackbar();
    const [notification, setNotification] = useState<Notification[]>([]);
    const [request, setRequest] = useState<boolean>(true);

    useEffect(() => {
        const response: Promise<AxiosResponse<Notification[]>> = close ? getImsClose() : getNotification();
        response.then(res => {
            if (res.data) {
                setNotification(res.data);
            }
        }).catch((error) => {
            console.log('Erro ao consultar notificação!', error);
            setSnackbar({ msg: "Erro ao consultar notificação!", type: 'error' });
        }).finally(function () {
            setRequest(false)
        });
    }, [close, setSnackbar]);

    return (
        <>
            {!!close ? (<ButtonBack to='/notificacao' />) : (
                <GridComponent >
                    <ButtonLink title="Criar Notificação" link='notificacao/nova-notificacao' icon={<AddIcon />} margin='0px 10px 0px 0px' />

                    <ButtonLink title="ims fechadas" link='notificacao/notificacoes-fechadas' color="secondary" icon={<AssignmentIcon />} />
                </GridComponent>
            )}

            <Card data={notification} request={request} close={close} />
        </>
    );
}
